<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>                   
            <FormRow inline>
              <div style="width: 100%">
                <FormLabel class="control-label"> Were you an advisor or alumni? </FormLabel>
                <FormInput
                  type="text"
                  class="width-full"
                  field="custom.advisorOrAlumni"
                />
              </div>
              <div style="width: 100%">
                <FormLabel class="control-label"> What is your birthday? </FormLabel>
                <input
                  type="date"
                  class="date-input"
                  @change="setDailyDate(new Date($event.target.value))"
                />
              </div>
            </FormRow>  
            <FormRow>
              <FormLabel>
                <input type="checkbox" field="custom.anonymous" v-model="anonymous" /> I
                would like my donation to be listed anonymously.
              </FormLabel>
            </FormRow>
            <br />            
          </FormSection>
        
          <FormSection title="Spouse's Details">
            <FormRow inline>
              <div style="width: 100%">
                <FormLabel class="control-label"> First <span style="color: red">*</span></FormLabel>
                <FormInput
                  type="text"
                  class="width-full"
                  field="custom.spouseFirstName"
                />
                <ErrorLabel field="custom.spouseFirstName" />
              </div>
              <div style="width: 100%">
                <FormLabel class="control-label"> Last <span style="color: red">*</span></FormLabel>
                <FormInput type="text" class="width-full" field="custom.spouseLastName" />
                <ErrorLabel field="custom.spouseLastName" />
              </div>
            </FormRow>
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
 
          <FormSection title="Designation">
            <FormLabel class="control-label" style="margin-bottom: 10px">
              Would you like your donation to be directed towards a specific region?
            </FormLabel>

            <NcsyIgniteDesignation />
          </FormSection>
          <FormSection title="">
            <InHonorOf />
          </FormSection>
          <FormSection title="Donation Amount">
            <div>
              <div>
    <div>
      <div class="styled-radio-container styled-radio-container--ou-donation row">
        <div class="radio-part">
          <input
          name="payment"
            id="monthly"
            type="radio"
            class="frequency"
            :checked="monthly && getValue('amount') === '83.33'"
            @click="
              setValue('dayOfMonth', '' + new Date().getDate());
              setValue('amount', '83.33');
            "
          />
          <FormLabel for="monthly">
            <div class="money_format label-amount">$83.33</div>
           <span class="label-description"> Monthly Donation</span>

          </FormLabel>
        </div>
        <div class="radio-part">
          <input
          name="payment"
            id="oneTime"
            type="radio"
            class="frequency"
            :checked="!monthly && getValue('amount') === '1000'"
            @click="
              setValue('dayOfMonth', null);
              setValue('periodMonths', null);
              setValue('amount', '1000');
            "
          />
          <FormLabel for="oneTime">
          <div class="money_format label-amount">$1,000</div>
           <span class="label-description">Single Donation</span></FormLabel>
        </div>        
      </div>
    </div>
    <FormRow class="monthly-note" v-if="monthly">
      <div>
        Your donation will be made today and on the <strong>{{ monthDay }}</strong> of
        each following month using the payment method selected. By selecting a recurring gift, you authorize ongoing charges that will continue until you request cancellation. <br /><br />
      </div>
    </FormRow>
  </div>
              <ErrorLabel field="amount" />
            </div>
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

import { queryParams } from "~/shared/query-params";

export default defineComponent({
  props: {
    subCampaign: String,
  },
  setup(props) {
    const { setValue, getValue, form, submit } = usePaymentForm();
    const anonymous = ref();

    setValue("custom.SwagSameAddess", "yes")
    watch(anonymous, () => {
      if (anonymous.value) {
        setValue("custom.anonymous", anonymous.value);
      }
    });
    
    watch(
      () => getValue("custom.designation"),
      (val) => {
        if (val == "NCSY_Atlanta_JSU") {
          setValue("applications.0.department", "NCSY_Atlanta");
          setValue("applications.0.campaign", "Ignite Legacy Society");
          setValue("applications.0.subCampaign", "JSU");
        } else if (val == "NCSY_Alumni") {
          setValue("applications.0.department", "NCSY_Alumni");
          setValue("applications.0.campaign", "Ignite Legacy Society");
          setValue("applications.0.subCampaign", "");
        } else if (val == "NCSY_Argentina") {
          setValue("applications.0.department", "NCSY_Argentina");
          setValue("applications.0.campaign", "Ignite Legacy Society");
          setValue("applications.0.subCampaign", "");
        } else if (val == "NCSY_Atlanta") {
          setValue("applications.0.department", "NCSY_Atlanta");
          setValue("applications.0.campaign", "Ignite Legacy Society");
          setValue("applications.0.subCampaign", "");
        } else if (val == "NCSY_AtlanticSeaboard") {
          setValue("applications.0.department", "NCSY_AtlanticSeaboard");
          setValue("applications.0.campaign", "Ignite Legacy Society");
          setValue("applications.0.subCampaign", "");
        } else if (val == "NCSY_Boston") {
          setValue("applications.0.department", "NCSY_Boston");
          setValue("applications.0.campaign", "Ignite Legacy Society");
          setValue("applications.0.subCampaign", "");
        } else if (val == "NCSY_Canada") {
          setValue("applications.0.department", "NCSY_Canada");
          setValue("applications.0.campaign", "Ignite Legacy Society");
          setValue("applications.0.subCampaign", "");
        } else if (val == "NCSY_CentralEast") {
          setValue("applications.0.department", "NCSY_CentralEast");
          setValue("applications.0.campaign", "Ignite Legacy Society");
          setValue("applications.0.subCampaign", "");
        } else if (val == "NCSY_Chile") {
          setValue("applications.0.department", "NCSY_Chile");
          setValue("applications.0.campaign", "Ignite Legacy Society");
          setValue("applications.0.subCampaign", "");
        } else if (val == "NCSY_Israel") {
          setValue("applications.0.department", "NCSY_Israel");
          setValue("applications.0.campaign", "Ignite Legacy Society");
          setValue("applications.0.subCampaign", "");
        } else if (val == "NCSY_Mexico") {
          setValue("applications.0.department", "NCSY_Mexico");
          setValue("applications.0.campaign", "Ignite Legacy Society");
          setValue("applications.0.subCampaign", "");
        } else if (val == "NCSY_Midwest") {
          setValue("applications.0.department", "NCSY_Midwest");
          setValue("applications.0.campaign", "Ignite Legacy Society");
          setValue("applications.0.subCampaign", "");
        } else if (val == "NCSY_Portland") {
          setValue("applications.0.department", "NCSY_Portland");
          setValue("applications.0.campaign", "Ignite Legacy Society");
          setValue("applications.0.subCampaign", "");
        } else if (val == "NCSY_Southern") {
          setValue("applications.0.department", "NCSY_Southern");
          setValue("applications.0.campaign", "Ignite Legacy Society");
          setValue("applications.0.subCampaign", "");
        } else if (val == "NCSY_Southwest") {
          setValue("applications.0.department", "NCSY_Southwest");
          setValue("applications.0.campaign", "Ignite Legacy Society");
          setValue("applications.0.subCampaign", "");
        } else if (val == "NCSY_STL") {
          setValue("applications.0.department", "NCSY_STL");
          setValue("applications.0.campaign", "Ignite Legacy Society");
          setValue("applications.0.subCampaign", "");
        } else if (val == "NCSY_Summer") {
          setValue("applications.0.department", "NCSY_Summer");
          setValue("applications.0.campaign", "Ignite Legacy Society");
          setValue("applications.0.subCampaign", "");
        } else if (val == "NCSY_Tristate") {
          setValue("applications.0.department", "NCSY_Tristate");
          setValue("applications.0.campaign", "Ignite Legacy Society");
          setValue("applications.0.subCampaign", "");
        } else if (val == "NCSY_WestCoast") {
          setValue("applications.0.department", "NCSY_WestCoast");
          setValue("applications.0.campaign", "Ignite Legacy Society");
          setValue("applications.0.subCampaign", "");
        } else {
          setValue("applications.0.department", "NCSY");
          setValue("applications.0.campaign", "Ignite Legacy Society");
          setValue("applications.0.subCampaign", "");
        }
      }
    );



    watch(
      () => getValue("custom.subDesignation"),
      (val) => {
        if(val == "4G" || !val) {
          setValue("applications.0.subCampaign", "4G");
         } 
      
        else {
          setValue("applications.0.subCampaign", "");
        }
      }
    );

    return {
      form,
      submit,
      anonymous,
      monthly: computed(() => !!form.value.dayOfMonth),
      getValue,
      setValue,
      monthDay: computed(() => {
        const i = +form.value.dayOfMonth!;

        const j = i % 10,
          k = i % 100;
        if (j == 1 && k != 11) {
          return i + "st";
        }
        if (j == 2 && k != 12) {
          return i + "nd";
        }
        if (j == 3 && k != 13) {
          return i + "rd";
        }
        return i + "th";
      }),
      setDailyDate(date: Date) {
        setValue(
          "custom.birthdate",
          new Date(
            Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
          ).toISOString()
        )
      },

    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
::v-deep h2 {
    font-style: normal;
    font-weight: 700 !important;
    font-size: 16px !important;
    margin-bottom: 16px !important;
    line-height: 24px !important;
    color: #080f16 !important;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}

::v-deep.styled-radio-container.styled-radio-container--ou-donation.row {

  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 16px;

  label {
    cursor: pointer;
    height: 100%;
    width: 100%;
    padding: 32px 46px;
    border-radius: 8px;
border: 2px solid  #EEEFF0;
background: #FFF;
    &:hover {
      background: #fafafa;
    }
    @media only screen and (max-width: 500px) {
      padding: 10px 14px;
    }
  }
  input {
    height: 0;
    top: 20px;
    position: absolute;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  .money_format{
    color: #1F262E;
text-align: center;
font-size: 24px;
font-style: normal;
padding-bottom: 10px;
font-weight: 700;
line-height: 24px; 
text-transform: capitalize;
  }
    .label-description {
    color: #9FA4AA;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    }
  input[type="radio"]:checked + label {
    border: 2px solid #1e50b4;
    .money_format {
      color: #1e50b4;
    }
    .label-description {
      color: #080f16;
    }
  }
}
::v-deep .form-container.ou-donation-form {
  margin: 0px auto !important;
    padding: 0px !important;
    border-radius: 0px !important;
    max-width: 100% !important;
    border: none !important;
}

::v-deepbutton#donate-widget-form-submit{
  background: #E56C15;
  border-color: #E56C15;
&:hover{
      background: #C25100;
}
}

.radio-container {
  display: flex;
  gap: 10px;
  align-items: center;
  padding-bottom: 5px;
}

.monthly-note {
  font-size: 13px;
  line-height: 1.4;
  margin-top: 10px;
  display: flex;
  align-items: center;

  .month-limit {
    margin-right: 20px;
    min-width: 110px;
  }
}

input#swag_yes, input#swag_no {
    position: relative;
    margin: 0px 0px 0px;
}
.date-input {
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  color: #222;
}

::v-deep label[for="firstName"]::after,
::v-deep label[for="lastName"]::after,
::v-deep label[for="email"]::after,
::v-deep label[for="street"]::after,
::v-deep label[for="city"]::after,
::v-deep label[for="state"]::after,
::v-deep label[for="zip"]::after,
::v-deep label[for="country"]::after,
::v-deep label[for="phone"]::after {
  content: " *";
  color: red;
}
</style>
